<ion-menu contentId="main-content" type="overlay" [swipeGesture]="false">
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none" class="sidemenu-item-content">
        <ion-avatar slot="start">
          <img [src]="settings.user.avatar" />
        </ion-avatar>
        <ion-label class="lbl">
          <strong
            ><p class="name">{{ settings.user.name }}</p></strong
          >
          <p class="title">{{ settings.user.email }}</p>
        </ion-label>
        <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list id="inbox-list">
      <ion-menu-toggle auto-hide="false">
        <ion-item lines="none">
          <ion-icon slot="start" name="grid-outline"></ion-icon>
          <ion-label>Sample</ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
</ion-menu>
